module.exports = __webpack_public_path__ + "img/add-icon.31421c17.svg";